import {
    BRAND_OWNER_CLIENTS_CREATE, BRAND_OWNER_CLIENTS_CREATE_RESET
} from "../constant/ActionType";

export default function getClientCreateData(state = {
    getbrandclientcreatedata: {},
    statuscode: null,
}, action) {
    switch (action.type) {
        case BRAND_OWNER_CLIENTS_CREATE:
            return {
                ...state,
                getbrandclientcreatedata: action?.data,
            };

        case BRAND_OWNER_CLIENTS_CREATE_RESET:
            return {
                ...state,
                getbrandclientcreatedata: {},
            };
        default:
    }

    return state;
}